var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4.8V6.4H27.2C29.851 6.4 32 8.54904 32 11.2V27.2C32 29.851 29.851 32 27.2 32H4.8C2.14904 32 0 29.851 0 27.2V11.2C0 8.54904 2.14904 6.4 4.8 6.4H8V4.8C8 2.14904 10.149 0 12.8 0H19.2C21.851 0 24 2.14904 24 4.8ZM20.8 6.4H11.2V4.8C11.2 3.91635 11.9164 3.2 12.8 3.2H19.2C20.0837 3.2 20.8 3.91635 20.8 4.8V6.4ZM11.2 17.6H3.2V27.2C3.2 28.0837 3.91635 28.8 4.8 28.8H27.2C28.0837 28.8 28.8 28.0837 28.8 27.2V17.6H20.8V19.2C20.8 20.0837 20.0837 20.8 19.2 20.8H12.8C11.9164 20.8 11.2 20.0837 11.2 19.2V17.6Z",
    fill: "#457E9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectImg1);
export default __webpack_public_path__ + "static/media/rect-img-1.64f462ff49a8999834590428b7ef98d4.svg";
export { ForwardRef as ReactComponent };